export default __webpack_public_path__ + "static/media/Thaikitchen1.2f8f88c1.jpg";